import { jsx as _jsx } from 'react/jsx-runtime';
export const IconCheck = (props) =>
  _jsx('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: _jsx('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M21.707 5.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9 16.586 20.293 5.293a1 1 0 0 1 1.414 0Z',
      fill: 'currentColor',
    }),
  });
IconCheck.displayName = 'IconCheck';
